import { axios } from '../utils/request'
import path from './path'


export function changePassword (params) {
    const url = '/' + path.apiName + '/user/change'
    return axios({
        url: url,
        method: 'post',
        data: params,
    })
}
